import { Person } from "../person/Person";
import { LegalInformation } from "./LegalInformation";
import { Location } from "./Location";
import { PaymentModel } from "./PaymentModel";
import { QualityLevel } from "./QualityLevel";

export class OrganisationPermission {
  organisation_id?: number
  deactivated_at?: string;
  employee_write?: boolean
  bid_read?: boolean
  bid_write?: boolean

  constructor(data: any) {
    this.organisation_id = data.organisation_id
    this.deactivated_at = data.deactivated_at;
    this.employee_write = data.employee_write ?? false
    this.bid_read = data.bid_read ?? false
    this.bid_write = data.bid_write ?? false
  }

  canWriteBid() {
    return this.bid_write === true
  }

  canReadBid() {
    return this.bid_read === true
  }


  static build(d: any): OrganisationPermission | undefined {
    if (!d) {
      return undefined
    }
    return new OrganisationPermission(d)
  }
}

export class Employee {
  person: Person;
  permissions?: OrganisationPermission

  constructor(data: any) {
    this.person = Person.build(data.person);
    this.permissions = OrganisationPermission.build(data.organisation_permission)
  }

  isEnable(): boolean {
    return !this.permissions?.deactivated_at
  }

  personId(): number {
    return this.person.id
  }

  static build(d: any): Employee {
    return new Employee(d);
  }

  static buildEmployeeFromInvitedUser(e: any): Employee {
    return new Employee({
      person: {
        id: -1,
        firstname: e.firstname,
        lastname: e.lastname,
        user: {
          email: e.email
        }
      }
    })
  }
}

export class Position {
  coordinates: number[];
  type?: string

  constructor(data: any) {
    this.coordinates = data.coordinates;
    this.type = data.type
  }

  static build(d: any): Position | undefined {
    if (!d) {
      return undefined
    }
    return new Position(d)
  }

  static isValid(d: any): d is Position {
    const c = d?.coordinates
    return Array.isArray(c) && c.length >= 2 && Number.isFinite(c[0]) && Number.isFinite(c[1])
  }
}

// Model for Organisation
export class Organisation {
  id
  directions: string;
  location: Location;
  name: string;
  position?: Position;
  type?: string
  timezone?: string
  has_ttp_data_access?: boolean

  constructor(data: any) {
    this.id = data.id
    this.directions = data.directions;
    this.location = Location.build(data.location);
    this.name = data.name;
    this.position = data.position ? new Position(data.position) : undefined
    this.type = data.type
    this.timezone = data.timezone
    this.has_ttp_data_access = data.has_ttp_data_access ?? false
  }

  isMill(): boolean {
    return this.type === "mill"
  }

  hasTtpDataAccess(): boolean {
    return this.has_ttp_data_access === true
  }

  static build(d): Organisation {
    if (d) {
      return new Organisation(d)
    }
  }
}

export class EconomicsModel {

  qbp?: QualityLevel[]
  legal_details?: LegalInformation

  constructor(e: any) {
    this.qbp = e.qbp.map(q => QualityLevel.build(q))
    this.legal_details = LegalInformation.build(e.legal_details)
  }

  static build(e: any): EconomicsModel {
    return new EconomicsModel(e)
  }
}
export class OrganisationModel {
  organisation?: Organisation
  employees?: Employee[]
  economics?: EconomicsModel
  payments?: PaymentModel

  constructor(d: any) {
    this.organisation = Organisation.build(d.org.organisation)
    var emp: Employee[] = d.org?.employees?.map(e => Employee.build(e))
      ?.sort((a: Employee, b: Employee) => a.person.getFullName().toLocaleLowerCase().localeCompare(b.person.getFullName().toLocaleLowerCase())) ?? []
    var invites = d.invites?.map(i => Employee.buildEmployeeFromInvitedUser(i))
    if (invites) {
      emp = [...emp, ...invites]
    }
    this.employees = emp
    this.economics = EconomicsModel.build(d.economics)
    this.payments = PaymentModel.build(d)
  }

  canWrite(id: number): boolean {
    return this.employees.find(e => e.personId() == id)?.permissions?.employee_write ?? false
  }

  hasPosition(): boolean {
    return this.organisation.position !== null && this.organisation.position !== undefined
  }

  isMill(): boolean {
    return this.organisation.type === "mill"
  }

  formatAddress(): string | null {
    var address = ""
    if (this.economics?.legal_details) {
      if (this.economics.legal_details?.address) {
        address += this.economics.legal_details?.address
      }

      if (this.economics.legal_details?.postal_code) {
        address = `${address ? address + `, ${this.economics.legal_details.postal_code}` : this.economics.legal_details.rt}`
      }

      if (this.economics.legal_details?.rw) {
        address = `${address ? address + `, RW ${this.economics.legal_details.rw}` : this.economics.legal_details.rw}`
      }

      if (this.economics.legal_details.rt) {
        address = `${address ? address + `, RT ${this.economics.legal_details.rt}` : this.economics.legal_details.rt}`
      }
    }
    return address.length === 0 ? null : address
  }


  // isInProgram() {
  //   return this.affiliate_reward_program !== undefined && this.affiliate_reward_program !== null
  // }

  static build(o: any): OrganisationModel {
    return new OrganisationModel(o)
  }
}